module.exports = __webpack_public_path__ + "static/media/ok.da2ad170.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ok.svg
// module id = 158
// module chunks = 0